export const HTTP_CODE_BAD_REQUEST: number = 400;
export const HTTP_CODE_UNAUTHORIZED: number = 401;
export const HTTP_CODE_FORBIDDEN: number = 403;
export const HTTP_CODE_NOT_FOUND: number = 404;
export const HTTP_CODE_UNPROCESSABLE_ENTITY: number = 422;

export const HTTP_CODE_LIST_USER_ERRORS: number[] = [
  HTTP_CODE_BAD_REQUEST,
  HTTP_CODE_UNAUTHORIZED,
  HTTP_CODE_FORBIDDEN,
  HTTP_CODE_NOT_FOUND,
  HTTP_CODE_UNPROCESSABLE_ENTITY,
];
